module.exports = __webpack_public_path__ + "images/kihnu/routes/pointers/TAL-AEG-TAL.png";